import { createTheme } from "@mui/material/styles";
import { DEFAULT_PRIMARY, DEFAULT_SECONDARY } from "./theme-utils";

export const getColorByPropertyValue = (value: string): string | null => {
  if (typeof document !== "undefined") {
    const computedValue = getComputedStyle(
      document.documentElement
    ).getPropertyValue(value);
    return computedValue.trim() || null;
  }
  return null;
};

export const resolveColor = (color: string): string => {
  if (color.startsWith("var(")) {
    const variableName = color.match(/var\(([^)]+)\)/)?.[1];
    if (variableName) {
      return getColorByPropertyValue(variableName) || color;
    }
  }
  return color;
};

/** Theme colors resolved from CSS variables (tenant theme). Use for MUI or JS. */
export const getThemeColor = () => {
  return {
    primaryColor: getColorByPropertyValue("--primaryColor") || DEFAULT_PRIMARY,
    secondaryColor:
      getColorByPropertyValue("--secondaryColor") || DEFAULT_SECONDARY,
    textColor: getColorByPropertyValue("--textColor") || "#040d13",
    textOnPrimary:
      getColorByPropertyValue("--textOnPrimary") || "#000000",
    textOnSecondary:
      getColorByPropertyValue("--textOnSecondary") || "#ffffff",
  };
};

/**
 * MUI theme. Palette main colors are defaults; at runtime components can use
 * getThemeColor() or CSS var(--primaryColor) so tenant theme is reflected.
 */
export const theme = createTheme({
  typography: {
    fontFamily: "ProximaNovaRegular",
  },
  palette: {
    primary: {
      main: DEFAULT_SECONDARY,
    },
    secondary: {
      main: DEFAULT_PRIMARY,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1025,
      lg: 1280,
      xl: 1920,
    },
  },
});
